import React from 'react'
import { useCreateInterviewTemplateForm } from 'components/modals/CreateInterviewTemplateModal/common/CreateInterviewTemplateForm/hooks'
import { useLanguage } from 'hooks'

export const useInternalState = (state, handlers) => {
  const { onCancel, onClose, onConfirm } = handlers

  const handleCancel = React.useCallback(() => {
    onCancel()
  }, [onCancel])

  const handleClose = React.useCallback(() => {
    onClose()
  }, [onClose])

  const {
    state: { competencies, control, formState },
    handlers: { handleFormSubmit, watch },
  } = useCreateInterviewTemplateForm(
    { onClose, onConfirm },
    { skills: state.skills },
  )

  const language = useLanguage()

  return {
    state: {
      form: { competencies, control, formState, watch },
      language,
    },
    handlers: {
      handleCancel,
      handleClose,
      handleConfirm: handleFormSubmit,
    },
  }
}
